export default [
  {
    title: "Dashboard",
    route: "dashboard",
    icon: "HomeIcon",
    action: "read",
    resource: "Auth",
  },
  {
    title: "客戶",
    route: "clients-list",
    icon: "UsersIcon",
    action: "read",
    resource: "client",
  },
  {
    title: "財務公司",
    route: "suppliers-list",
    icon: "MonitorIcon",
    action: "read",
    resource: "supplier",
  },
  {
    title: "貸款記錄",
    route: "loans-list",
    icon: "CreditCardIcon",
    action: "read",
    resource: "loan",
  },
  {
    title: "合同管理",
    route: "contracts-list",
    icon: "FileTextIcon",
    action: "read",
    resource: "Auth",
  },
  {
    title: "破產令管理",
    route: "",
    icon: "FileMinusIcon",
    children: [
      {
        title: "上傳PDF",
        route: "bankruptcy-upload",
        action: "read",
        resource: "Auth",
      },
      {
        title: "記錄列表",
        route: "bankruptcy-list",
        action: "read",
        resource: "Auth",
      },
    ],
  },
  {
    title: "法院案件管理",
    route: "",
    icon: "FileTextIcon",
    children: [
      {
        title: "高等法院破產呈請案件",
        route: "court-cases-list",
        action: "read",
        resource: "Auth",
      },
      {
        title: "其他法庭案件",
        route: "other-court-cases-list",
        action: "read",
        resource: "Auth",
      },
    ],
  },
  {
    title: "充值記錄",
    route: "payment-record-list",
    icon: "DollarSignIcon",
    action: "read",
    resource: "payment",
  },
  {
    title: "通告",
    route: "blog-list",
    icon: "AtSignIcon",
    action: "read",
    resource: "blog",
  },
  {
    title: "審批放債人號碼",
    route: "approves-list",
    icon: "ApertureIcon",
    action: "read",
    resource: "supplier",
  },
  {
    title: "審批會員合約",
    route: "member-approves-list",
    icon: "UserCheckIcon",
    action: "read",
    resource: "supplier",
  },
  {
    title: "續費/加購額度記錄",
    route: "member-membership-logs-list",
    icon: "UserPlusIcon",
    action: "read",
    resource: "supplier_membership_log",
  },
  /*   {
    title: "中獎記錄",
    route: "wheel-get-award-record",
    icon: "GiftIcon",
    action: "read",
    resource: "draw",
  }, */
  {
    title: "搜尋報告",
    route: "suppliers-searchcount-list",
    icon: "SearchIcon",
    action: "read",
    resource: "supplier",
  },

  {
    title: "頁面",
    route: "pages-list",
    icon: "BookmarkIcon",
    action: "read",
    resource: "page",
  },
  {
    title: "設定",
    route: "",
    icon: "SettingsIcon",
    children: [
      {
        title: "獎品設定",
        route: "wheel-award-list",
        // icon: "GiftIcon",
        action: "read",
        resource: "drawsetting",
      },
      {
        title: "系統設定",
        route: "settings-list",
        action: "read",
        resource: "user",
      },
      {
        title: "員工資料",
        route: "users-list",
        action: "read",
        resource: "user",
      },
      {
        title: "員工職位及權限",
        route: "roles-list",
        action: "read",
        resource: "user",
      },
      {
        title: "App技術支援管理",
        route: "admin-app-support",
        action: "read",
        resource: "app",
      },
      {
        title: "合約驗證日誌",
        route: "contract-logs",
        action: "read",
        resource: "user",
      },
    ],
  },
];
